import { Injectable } from '@angular/core';
import { UnitsV2 } from '@schenck/rotec-components';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import { RotorType } from 'src/utils/interfaces/rotor-type.interfaces';

export class RotorTypeModel implements RotorType {
  constructor(
    public readonly name: string,
    public readonly description: string,
    public readonly status: string,
    public readonly syncEnabled: boolean
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class RotorTypeAdapter implements Adapter<RotorTypeFormsData, RotorType> {
  /**
   * Creates the adapted form data
   *
   * @param formData: RotorTypeFormsData
   * @param units: UnitsV2[]
   * @param status: string
   * @returns RotorType
   */
  public adapt(formData: RotorTypeFormsData, units?: UnitsV2[], status?: string): RotorType {
    return new RotorTypeModel(
      formData.rotorTypeSettingsStep.rotorTypeName,
      formData.rotorTypeSettingsStep.rotorTypeDescription,
      status,
      formData.summaryStep.cloudSync
    );
  }
}
